package one.healthium.fodmap.presentation.navigation.today

import androidx.compose.runtime.Composable
import one.healthium.today.ui.fodmap.TodayScreen

@Composable
fun TodayContent(
    component: TodayComponent,
) {
    TodayScreen(component)
}